import InfoLayout from "./InfoLayout";

function PrivacyPolicy() {
    return (
        <InfoLayout title="Ochrana údajů">
                       <h2>Sbírání dat</h2>
                <p>
                    Tato freemium verze aplikace <strong>Tabata Timer</strong> nesbírá žádná citlivá osobní data. 
                    Nepotřebujeme vaše jméno, e-mail ani žádné jiné identifikační údaje.
                </p>

                <h2>Analytika a anonymní data</h2>
                <p>
                    Pro zlepšení funkcí aplikace používáme <strong>Google Analytics</strong>, který shromažďuje pouze anonymní statistiky používání aplikace,
                    například počet návštěv, dobu trvání cvičení a typ zařízení. Tyto informace nám pomáhají optimalizovat aplikaci a zpříjemnit uživatelský zážitek.
                </p>

                <h2>Sdílení dat</h2>
                <p>
                    Vaše osobní údaje s třetími stranami <strong>nesdílíme</strong>, protože žádné osobní údaje neshromažďujeme.
                </p>


                <h2>Bezpečnost</h2>
                <p>
                    I když neshromažďujeme citlivé údaje, dbáme na zabezpečení serverů a ochranu anonymních dat proti zneužití.
                </p>

                <h2>Kontakt</h2>
                <p>
                    Máte-li dotazy ohledně ochrany soukromí, napište nám na: <strong>admin@tabataworkout.online</strong>
                </p>

                <h2>Aktualizace zásad</h2>
                <p>
                    Tyto zásady se mohou čas od času měnit. Doporučujeme sledovat aktuální verzi na této stránce.
                </p>
        </InfoLayout>
    );
}

export default PrivacyPolicy;
